<section class="container-fluid">
    <div class="row">
        <button class="btn btn-primary" (click)="processData()">Data Processing...</button>
    </div>
</section>
